import { render } from "./PDF.vue?vue&type=template&id=035bb65f&scoped=true"
import script from "./PDF.vue?vue&type=script&lang=js"
export * from "./PDF.vue?vue&type=script&lang=js"

import "./PDF.vue?vue&type=style&index=0&id=035bb65f&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-035bb65f"]])

export default __exports__